import {useQuery} from '@tanstack/react-query'

import type {GetTenantConfigResponse} from 'interfaces'
import {PBFFService} from 'services/api'

/** React Query key for `GET /tenant/config` (PBFF). */
export const TENANT_CONFIG_QUERY_KEY = 'getTenantConfig'

/**
 * Loads tenant config from the portal BFF. Callers decide how to interpret
 * `data` (e.g. residency gating) using `isSuccess` / error state as needed.
 */
export const useTenantConfigQuery = () =>
  useQuery<GetTenantConfigResponse>({
    queryKey: [TENANT_CONFIG_QUERY_KEY],
    queryFn: () => PBFFService.getTenantConfig(),
  })
